import { z } from "zod";
import { postStatusSchema, slugSchema } from "./post";

const amount = z.number().int().min(0).max(99_999_999);
const fields = {
  title: z.string().trim().min(3).max(140),
  type: z.enum(["service", "product"]),
  summary: z.string().trim().min(10).max(300),
  descriptionMd: z.string().min(1).max(60_000),
  priceFromMinor: amount,
  priceToMinor: amount.nullable(),
  currency: z.enum(["USD", "GBP", "EUR"]),
  priceBasis: z.enum(["fixed", "hour", "report", "project"]),
  status: postStatusSchema,
};

function priceRange(input: { priceFromMinor: number; priceToMinor: number | null }) {
  return input.priceToMinor === null || input.priceToMinor >= input.priceFromMinor;
}
const rangeError = {
  message: "The upper price must be at least the starting price.",
  path: ["priceToMinor"],
};

export const shopListingSchema = z
  .object({
    slug: slugSchema,
    ...fields,
    salesMode: z.literal("enquiry"),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    publishedAt: z.iso.datetime().nullable(),
  })
  .refine(priceRange, rangeError);

export const shopCreateSchema = z
  .strictObject({
    slug: slugSchema,
    ...fields,
    status: postStatusSchema.default("draft"),
  })
  .refine(priceRange, rangeError);

export const shopPatchSchema = z
  .strictObject(fields)
  .partial()
  .refine((patch) => Object.values(patch).some((value) => value !== undefined), {
    message: "Give at least one field to change.",
  });

export type ShopListing = z.infer<typeof shopListingSchema>;
export type ShopCreate = z.infer<typeof shopCreateSchema>;
export type ShopPatch = z.infer<typeof shopPatchSchema>;
